import React from 'react'
import { Header } from 'semantic-ui-react'
import AllocationTradeFieldsPreview from './components/AllocationTradeFieldsPreview'
import ApexTradeFieldsPreview from './components/ApexTradeFieldsPreview'
import AwayTradeFieldsPreview from './components/AwayTradeFieldsPreview'
import { tradeTypeEnumToDisplay } from './helpers'
import styles from './styles.module.less'
import { TradeFormValues, TradeTypeEnum } from './Types'

const CounterPartyDetailsPreview = ({ values }: { values: TradeFormValues }) => {
  const { tradeType } = values

  const PreviewComponent: ({ values }: { values: TradeFormValues }) => JSX.Element = {
    [TradeTypeEnum.awayTrade]: AwayTradeFieldsPreview,
    [TradeTypeEnum.execution]: ApexTradeFieldsPreview,
    [TradeTypeEnum.allocation]: AllocationTradeFieldsPreview,
  }[tradeType]

  return (
    <div className={`counter-party-details-preview ${styles.counterPartyDetailsPreview}`}>
      <Header as="h2">Counterparty Details</Header>
      <p>Trade Type: {tradeTypeEnumToDisplay(tradeType)}</p>
      <PreviewComponent values={values} />
    </div>
  )
}

export default CounterPartyDetailsPreview
